/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Mx_TeamchatInputs */

const en_mk_mx_teamchat = /** @type {(inputs: Mk_Mx_TeamchatInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Team chat, threads, direct messages`)
};

const id_mk_mx_teamchat = /** @type {(inputs: Mk_Mx_TeamchatInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chat tim, thread, pesan langsung`)
};

/**
* | output |
* | --- |
* | "Team chat, threads, direct messages" |
*
* @param {Mk_Mx_TeamchatInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_mx_teamchat = /** @type {((inputs?: Mk_Mx_TeamchatInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Mx_TeamchatInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_mx_teamchat(inputs)
	return en_mk_mx_teamchat(inputs)
});